// extracted by mini-css-extract-plugin
export default {"levelSelect":"styles_levelSelect__+uAL+"};